import React from "react";

export default function BonusDrawHeader({ children }) {
  return (
    <div className='container'>
      <div className='bonus-draw__top'>{children}</div>
    </div>
  );
}
